import React, { useState, useEffect } from 'react'
import * as icons from 'react-icons/fa';
import './Pages.css';
import API_URL from '../config/config';
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';

const initialState = {
    quotation_ref_no: "",
    enddate: "",
    startdate: "",
    response_type: "",
    filename: ""

}

export default function POall() {

    const navigate = useNavigate();
    const [cookies] = useCookies([]);

    useEffect(() => {
        const verifyUser = async () => {
            if (!cookies.jwt) {
                navigate("/");
            }
        };
        verifyUser();
    });

    const [userData, setUserData] = useState([]);

    useEffect(() => {

        const lodeUserData = async () => {
            await axios.post(API_URL + "/profile", {},
                {
                    withCredentials: true,
                })
                .then((resp) => setUserData({ ...resp.data[0] }))
        }

        lodeUserData();
    }, []);

    const [state, setState] = useState(initialState);
    const { quotation_ref_no, enddate, startdate, response_type } = state;

    const [data, setData] = useState([]);
    const lodeData = async () => {
        const response = await axios.get(API_URL + "/allpo");
        setData(response.data);
    }

    const handleQRN = async (e) => {
        e.preventDefault();
        const response = await axios.get(API_URL + `/searchQuotationRefNo/${quotation_ref_no}`)
        setData(response.data);
    }

    const handleDate = async (e) => {
        e.preventDefault();
        const response = await axios.get(API_URL + `/searchQDate/${startdate}/${enddate}`)
        setData(response.data);
    }

    const handleResponseType = async (e) => {
        e.preventDefault();
        const response = await axios.get(API_URL + `/searchResponseType/${response_type}`)
        setData(response.data);
    }

    const handleReset = (e) => {

        lodeData()
            .then(() => {
                setState({
                    quotation_ref_no: "",
                    enddate: "",
                    startdate: "",
                    response_type: ""
                });
            });
    };

    const handleEdit = (po_ref_no) => {
        navigate(`/editpo/${po_ref_no}`);
    };

    const handleview = (po_ref_no) => {

        navigate(`/viewpo/${po_ref_no}`);
    };

    useEffect(() => {
        lodeData();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setState({ ...state, [name]: value })
    };

    return (
        <div className='background'>
            <div className='container-fluid contentbox p-4'>
                <div className='row'>

                    <div className='row'>
                        <div className=' col-12'>
                            <div className='fleft mx-3'>
                                <h2>Purchase Orders</h2>
                            </div>
                        </div>

                    </div>
                    <div className='row mt-2'>
                        <div className='col-12'>

                            {/* <div className="fleft mx-3 btn-group col-9" role="group" >
                                <a href='/quotationstoverify' role='button' className="btn btn-outline-primary">To verify</a>
                                <a href='/quotationstocheck' role='button' className="btn btn-outline-primary">To Check</a>
                                <a href='/quotationstoapproval' role='button' className="btn btn-outline-primary">To Approval</a>
                                <a href='/quotationstoorder' role='button' className="btn btn-outline-primary">To Order</a>
                                <a href='/quotationsall' role='button' className="btn btn-primary">Complete</a>
                            </div> */}

                            <div className="fright btn-group col-2">
                                {userData.account_type === "user" ?
                                    <a href='/addpo' className='btn btn-outline-success' role='button'><icons.FaPlusCircle /> Add PO </a>
                                    : null}
                            </div>
                        </div>
                    </div>

                    <div>
                         {/*<div className='row'>
                            <div className=' col-12'>

                                <div className='fleft mx-3 mt-2'>
                                    <div className='input-group'>
                                        <div className="form-outline">
                                            <input type="search" className="form-control" placeholder='Quotation Ref. No...' name='quotation_ref_no' value={quotation_ref_no} onChange={handleInputChange}></input>

                                        </div>
                                        <button type="button" className="btn btn-success" onClick={handleQRN}><icons.FaSearch /></button>
                                    </div>
                                </div>

                                <div className='fleft mx-3 mt-2'>
                                    <div className='input-group'>
                                        <div className="form-outline">
                                            <input type="date" className="form-control" name='startdate' value={startdate} onChange={handleInputChange}></input>
                                        </div>
                                        <div className="form-outline">
                                            <input type="date" className="form-control" name='enddate' value={enddate} onChange={handleInputChange}></input>
                                        </div>
                                        <button type="button" className="btn btn-success" onClick={handleDate}><icons.FaFilter /></button>
                                    </div>
                                </div>

                                <div className='fleft mx-3 mt-2'>
                                    <div className='input-group'>
                                        <div className="form-outline">
                                            <select name="response_type" className="form-control" value={response_type} onChange={handleInputChange}>
                                                <option value="">Response Type...</option>
                                                <option value="accept">Accept</option>
                                                <option value="reject">Reject</option>
                                                <option value="pending">Pending</option>
                                            </select>
                                        </div>
                                        <button type="button" className="btn btn-success" onClick={handleResponseType}><icons.FaFilter /></button>
                                    </div>
                                </div>

                                <div className='fleft mt-2 mx-3'>
                                    <button type='button' className='btn btn-success ' onClick={handleReset}>Reset</button>
                                </div>

                            </div>
                        </div> */}

                        <div className='row'>
                            <div className='mt-3 mx-3'>

                                <div className='table-responsive me-3'>
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">PO<br />Ref. No.</th>
                                                <th scope="col">Date</th>
                                                <th scope="col">Supplier</th>
                                                <th scope="col">Action</th>

                                            </tr>
                                        </thead>

                                        <tbody>
                                            {data.map((po, index) => (
                                                <tr key={index}>
                                                    <td>{po.po_ref_no}</td>
                                                    <td>{moment(po.date).format("YYYY/MM/DD")}</td>
                                                    <td>{po.supplier_name}</td>

                                                    <td className='d-flex'>
                                                        <button type="button" className='btnNoBackground' onClick={() => handleview(po.po_ref_no)}><icons.FaEye /></button>

                                                        &nbsp; &nbsp;&nbsp;&nbsp;

                                                        {userData.account_type === "admin" || userData.account_type === "user" ?
                                                            <button type="button" className='btnNoBackground' onClick={() => handleEdit(po.po_ref_no)}><icons.FaEdit /></button>
                                                            : null}
                                                        &nbsp;
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <ToastContainer />
        </div >
    )
}
